import { format, unwrapFunctionStore } from 'svelte-i18n';

const $format = unwrapFunctionStore(format);

export const cloningSignature = {
  popover: {
    title: $format('label.TOURS.STUDIO.CLONE.CLONING_SIG.TITLE'),
    description: $format('label.TOURS.STUDIO.CLONE.CLONING_SIG.DESCRIPTION')
  }
};
